import { useState, FormEvent, ChangeEvent } from "react";
import { useTranslation } from "react-i18next";

export default function ConsultFormSection() {
  const { t } = useTranslation();
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    lineId: "",
    location: "",
    question: "",
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    fetch("https://readdy.ai/api/form/d7ua2al8ka4otec5ptbg", {
      method: "POST",
      body: new URLSearchParams(data as unknown as Record<string, string>),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    }).then(() => {
      setSubmitted(true);
      setFormData({ name: "", phone: "", lineId: "", location: "", question: "" });
    });
  };

  if (submitted) {
    return (
      <section className="section-padding bg-cream" id="consult">
        <div className="container-main">
          <div className="max-w-2xl mx-auto text-center bg-white rounded-2xl border border-warm-gray/60 p-10 md:p-14">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-champagne/10 mx-auto mb-6">
              <i className="ri-checkbox-circle-line text-3xl text-champagne" />
            </div>
            <h3 className="mb-4">{t("portfolio.form.success")}</h3>
            <button onClick={() => setSubmitted(false)} className="btn-outline mt-2">
              再次送出
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="section-padding bg-cream" id="consult">
      <div className="container-main">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <span className="tag-label mb-4 inline-block">{t("portfolio.form.label")}</span>
          <h2 className="mb-4">{t("portfolio.form.title")}</h2>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-2xl border border-warm-gray/60 p-6 md:p-10">
            <form data-readdy-form onSubmit={handleSubmit} className="space-y-5">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="pf-name" className="block text-base font-sans font-semibold text-graphite mb-2">
                    {t("portfolio.form.name")}
                  </label>
                  <input
                    id="pf-name"
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-warm-gray bg-cream/50 text-graphite text-[1.0625rem] font-sans focus:outline-none focus:border-champagne focus:ring-1 focus:ring-champagne/30 transition-all"
                  />
                </div>
                <div>
                  <label htmlFor="pf-phone" className="block text-base font-sans font-semibold text-graphite mb-2">
                    {t("portfolio.form.phone")}
                  </label>
                  <input
                    id="pf-phone"
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-warm-gray bg-cream/50 text-graphite text-[1.0625rem] font-sans focus:outline-none focus:border-champagne focus:ring-1 focus:ring-champagne/30 transition-all"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="pf-lineId" className="block text-base font-sans font-semibold text-graphite mb-2">
                    {t("portfolio.form.lineId")}
                  </label>
                  <input
                    id="pf-lineId"
                    type="text"
                    name="lineId"
                    value={formData.lineId}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-warm-gray bg-cream/50 text-graphite text-[1.0625rem] font-sans focus:outline-none focus:border-champagne focus:ring-1 focus:ring-champagne/30 transition-all"
                  />
                </div>
                <div>
                  <label htmlFor="pf-location" className="block text-base font-sans font-semibold text-graphite mb-2">
                    {t("portfolio.form.location")}
                  </label>
                  <input
                    id="pf-location"
                    type="text"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-warm-gray bg-cream/50 text-graphite text-[1.0625rem] font-sans focus:outline-none focus:border-champagne focus:ring-1 focus:ring-champagne/30 transition-all"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="pf-question" className="block text-base font-sans font-semibold text-graphite mb-2">
                  {t("portfolio.form.question")}
                </label>
                <textarea
                  id="pf-question"
                  name="question"
                  value={formData.question}
                  onChange={handleChange}
                  rows={4}
                  maxLength={500}
                  required
                  className="w-full px-4 py-3 rounded-lg border border-warm-gray bg-cream/50 text-graphite text-[1.0625rem] font-sans focus:outline-none focus:border-champagne focus:ring-1 focus:ring-champagne/30 transition-all resize-none"
                />
                <p className="text-base text-medium-gray text-right mt-1">{formData.question.length}/500</p>
              </div>

              <button type="submit" className="btn-primary w-full sm:w-auto">
                {t("portfolio.form.submit")}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}